export default __webpack_public_path__ + "images/48d56a1324db21fb6b806176abd48ed5-wanderlust_logo@2x.png";